__webpack_require__.p = "https://www.turystyka.allianz.pl/direct/";